import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAccounts } from '../services/accounts-data.service';
import { getIsHubless } from '../reducers/Portal';
import { DataFetchingError } from '../errors/DataFetchingError';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
import { RequestStatus } from '../interface';
import { selectAccountsDataState } from '../selectors/accounts-data.selectors';
const defaultResponse = {
  basicAccounts: [],
  pinnedAccountIds: [],
  isImpersonating: false
};
export const getAccountsDataThunk = createAsyncThunk('getAccountsData', async (portalId, {
  rejectWithValue,
  getState
}) => {
  const state = getState();
  const isHubless = getIsHubless(state);
  if (isHubless || !portalId) {
    return rejectWithValue(defaultResponse);
  }
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  try {
    return await getAccounts(portalId);
  } catch (error) {
    const requestError = error;
    logger.error(new DataFetchingError('Failed to fetch accounts', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue(defaultResponse);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectAccountsDataState(state);
    return status === RequestStatus.IDLE;
  }
});